export { fetchLocstrings, clearSuccessfulLoadedUrls } from './fetchLocstrings';
export { preloadLocStrings, cachePreloadUrls, addPreloadUrl } from './preloadLocStrings';

export const LocalStoreLocaleKey = 'OwaLocale';
